import { useEffect, useState } from "react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import React from "react";
import "./common.css";
import { fetchCastingImages } from "../../api/castingcallApi/castingcallApi"; 

const SwiperComponent = () => {
  const [imagesGroup1, setImagesGroup1] = useState([]);
  const [imagesGroup2, setImagesGroup2] = useState([]);

  useEffect(() => {
    const loadImages = async () => {
      const images = await fetchCastingImages();

    
      const groupedImages = [];
      for (let i = 0; i < images.length; i += 3) {
        groupedImages.push(images.slice(i, i + 3));
      }

      setImagesGroup1(groupedImages);
      setImagesGroup2(images);
    };

    loadImages();
  }, []);

  return (
    <div className="carousel-wrapper">
      {/* First Swiper */}
      <div className="carousel1">
        <Swiper
          spaceBetween={50}
          slidesPerView={1}
          navigation
          autoplay={{
            delay: 4000,
            disableOnInteraction: false,
          }}
          speed={2000}
          modules={[Navigation, Pagination, Autoplay]}
        >
          {imagesGroup1.map((group, index) => (
            <SwiperSlide key={index}>
              <div className="slide-container">
                <div className="slides-wrapper">
                  {group.map((item, imgIndex) => (
                    <div
                      key={imgIndex}
                      className="slide-image-div"
                      onClick={() => window.open(item.websiteUrl, "_blank")}
                      style={{ cursor: "pointer" }}
                    >
                      <img src={item.imageUrl} alt={`Slide ${imgIndex}`} className="slide-image" />
                    </div>
                  ))}
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* Second Swiper */}
      <div className="carousel2">
        <Swiper
          spaceBetween={50}
          slidesPerView={1}
          navigation
          autoplay={{
            delay: 4000,
            disableOnInteraction: false,
          }}
          speed={2000}
          modules={[Navigation, Pagination, Autoplay]}
        >
          {imagesGroup2.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="slide-container">
                <div
                  className="slide-image-div"
                  onClick={() => window.open(item.websiteUrl, "_blank")}
                  style={{ cursor: "pointer" }}
                >
                  <img src={item.imageUrl} alt={`Slide ${index}`} className="slide-image" />
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default SwiperComponent;
